import { isEmpty } from 'lodash';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  RsuAwardApprovalService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_RsuAwardListDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetRsuAwardsParticipantsList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_RsuAwardListDto | undefined,
  unknown
> => {
  const {
    approvalStatusId,
    optionAcceptance: rsuAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    grantFromDate,
    grantToDate,
    filter,
    sorting,
    skipCount,
    maxResultCount,
    employeeStatusId,
    _force,
  } = tableInfo;
  const rsuStatus = 0;

  const RsuAwardsParticipantApprovalData = useQuery(
    [
      'getRsuAwardsParticipantApprovalList',
      approvalStatusId,
      fromDate,
      toDate,
      employeeStatusId,
      rsuStatus,
      rsuAcceptance,
      createdFromDate,
      createdToDate,
      grantFromDate,
      grantToDate,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        RsuAwardApprovalService.getApiAwardApiAppRSUAwardApprovalRSUAwardList(
          !isEmpty(approvalStatusId) ? approvalStatusId : [0],
          fromDate,
          toDate,
          employeeStatusId ?? [0],
          rsuStatus,
          rsuAcceptance,
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return RsuAwardsParticipantApprovalData;
};

export default useGetRsuAwardsParticipantsList;
